import { bureauPlatformApi } from '@/utils/api';
import { AxiosError } from 'axios';
import { useMutation, UseMutationOptions, UseMutationResult } from 'react-query';

export interface LiveModeRequestFormData {
  companyName?: string;
  gstNumber?: string;
  state?: string;
  city?: string;
  zipCode?: string;
}

interface LiveRequestSubmissionResponse {
  status: string;
}

const useLiveModeRequestSubmission = (
  options?: UseMutationOptions<LiveRequestSubmissionResponse, AxiosError, {}>,
): UseMutationResult<LiveRequestSubmissionResponse, AxiosError, LiveModeRequestFormData> =>
  useMutation(submitLiveModeRequest, options);

const submitLiveModeRequest = async (requestData: LiveModeRequestFormData): Promise<LiveRequestSubmissionResponse> => {
  const { data: response } = await bureauPlatformApi.post<LiveRequestSubmissionResponse>(
    'v1/auth/customers',
    requestData,
  );
  return response;
};

export default useLiveModeRequestSubmission;
